import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectCalendarDate } from '@shared/store/dashboard.duck';
import { DialogIdentifiers, openDialogWithPayload } from '@shared/store/dialog.duck';
import IconButton from "./icon-button/IconButton";
import { IconTypes } from "../atoms/icon/Icon";
import styled from "styled-components";
import { selectCurrentUser } from '@shared/store/auth.duck';
import { WeekNoteScope } from '@features/whereabouts/services/WeekNotesService';
import Colours from "../atoms/Colours";

export function ShowWeekNotesButton(props: Props) {
  const dispatch = useDispatch();
  const calendarDate = useSelector(selectCalendarDate);
  const user = useSelector(selectCurrentUser);

  const onClick = () => {
    dispatch(openDialogWithPayload({
      payload: { date: calendarDate, scope: props.scope ?? { type: 'TEAM', id: props.teamId } },
      activeDialog: DialogIdentifiers.WeeklyNotes
    }));
  }

  if (!user?.companyEntity.weeklyNotesEnabled) {
    return null;
  }

  return (
    <Wrapper>
      <IconButton text={"week-notes.week-notes"}
                  style={{...props?.style ?? {}}}
                  onClick={onClick}
                  icon={IconTypes.Email} />
      {props.hasWeekNotesToView && <AvailableCircle />}
    </Wrapper>
  )
}

interface Props {
  style?: any;
  teamId: string;
  // Optional explicit scope; defaults to the team identified by teamId. Lets workgroup/department
  // wall-charts open the same dialog scoped to their own group.
  scope?: WeekNoteScope;
  hasWeekNotesToView?: boolean;
}

const Wrapper = styled.div`
  position: relative;
  cursor: pointer;
  padding: 2px 12px;
  margin-right: -12px;
  border-radius: 8px;
  i {
    font-size: 16px;
    width: unset;
  }
  &:hover {
    background-color: ${Colours.veryLightGrey};
  }
  * {
    &:hover {
      background-color: unset !important;
    }
  }
`

const AvailableCircle = styled.div`
  border-radius: 100%;
  width: 12px;
  height: 12px;
  background-color: ${Colours.blue};
  top: 4px;
  right: 116px;
  position: absolute;
`
